import * as React from "react";

const SvgPencilalt = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M10.533 6H5.867C4.836 6 4 6.836 4 7.867v10.266C4 19.164 4.836 20 5.867 20h10.266A1.867 1.867 0 0 0 18 18.133v-4.666" />
      <path d="M16.87 4.537a1.833 1.833 0 1 1 2.593 2.593L11.593 15H9v-2.593l7.87-7.87Z" />
    </g>
  </svg>
);

export default SvgPencilalt;
